import { backend } from "declarations/backend";

let isUploading = false;

async function loadFiles() {
    try {
        const files = await backend.getAllFiles();
        displayFiles(files);
    } catch (error) {
        console.error("Error loading files:", error);
    }
}

function displayFiles(files) {
    const filesContainer = document.getElementById('filesContainer');
    filesContainer.innerHTML = '';
    
    files.forEach(file => {
        const fileDiv = document.createElement('div');
        fileDiv.className = 'file-item';
        
        const fileInfo = document.createElement('div');
        fileInfo.className = 'file-info';
        
        const fileName = document.createElement('div');
        fileName.className = 'file-name';
        fileName.textContent = file.name;
        
        const fileMeta = document.createElement('div');
        fileMeta.className = 'file-meta';
        fileMeta.textContent = `${formatFileSize(file.size)} • ${formatDate(file.createdAt)}`;
        
        fileInfo.appendChild(fileName);
        fileInfo.appendChild(fileMeta);
        
        const actionDiv = document.createElement('div');
        actionDiv.className = 'file-actions';
        
        const downloadBtn = document.createElement('button');
        downloadBtn.className = 'btn btn-download';
        downloadBtn.textContent = 'Download';
        downloadBtn.onclick = () => downloadFile(file.id);
        
        const deleteBtn = document.createElement('button');
        deleteBtn.className = 'btn btn-delete';
        deleteBtn.textContent = 'Delete';
        deleteBtn.onclick = () => deleteFile(file.id);
        
        actionDiv.appendChild(downloadBtn);
        actionDiv.appendChild(deleteBtn);
        
        fileDiv.appendChild(fileInfo);
        fileDiv.appendChild(actionDiv);
        filesContainer.appendChild(fileDiv);
    });
}

function formatFileSize(bytes) {
    if (bytes == 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function formatDate(timestamp) {
    const date = new Date(Number(timestamp) / 1000000);
    return date.toLocaleDateString();
}

async function uploadFile() {
    if (isUploading) return;
    
    const fileInput = document.getElementById('fileInput');
    const file = fileInput.files[0];
    
    if (!file) {
        alert('Please select a file first');
        return;
    }
    
    const uploadText = document.getElementById('uploadText');
    const uploadSpinner = document.getElementById('uploadSpinner');
    
    try {
        isUploading = true;
        uploadText.classList.add('d-none');
        uploadSpinner.classList.remove('d-none');
        
        const arrayBuffer = await file.arrayBuffer();
        const fileContent = new Uint8Array(arrayBuffer);
        
        await backend.uploadFile(file.name, fileContent, file.type);
        await loadFiles();
        
        fileInput.value = '';
    } catch (error) {
        console.error("Error uploading file:", error);
        alert('Failed to upload file');
    } finally {
        isUploading = false;
        uploadText.classList.remove('d-none');
        uploadSpinner.classList.add('d-none');
    }
}

async function downloadFile(id) {
    try {
        const file = await backend.getFile(id);
        if (!file) {
            alert('File not found');
            return;
        }
        
        const blob = new Blob([file.content], { type: file.fileType });
        const url = URL.createObjectURL(blob);
        
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading file:", error);
        alert('Failed to download file');
    }
}

async function deleteFile(id) {
    if (!confirm('Are you sure you want to delete this file?')) return;
    
    try {
        await backend.deleteFile(id);
        await loadFiles();
    } catch (error) {
        console.error("Error deleting file:", error);
        alert('Failed to delete file');
    }
}

document.getElementById('uploadButton').addEventListener('click', uploadFile);

// Load initial files
loadFiles();
